import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] w-full">
            <div className="relative w-16 h-16 mb-4">
                <div className="absolute top-0 left-0 w-full h-full border-4 border-gray-200 dark:border-gray-700 rounded-full"></div>
                <div className="absolute top-0 left-0 w-full h-full border-4 border-primary-light rounded-full animate-spin border-t-transparent"></div>
            </div>
            <p className="text-gray-500 dark:text-gray-400 font-medium animate-pulse">Loading...</p>
        </div>
    );
};

export default LoadingSpinner;
